/** True when the event target is inside a portaled Headless UI listbox menu. */
export function isPortaledListboxInteraction(target: Node | null): boolean {
  if (!(target instanceof Element)) return false;
  return Boolean(target.closest('[role="listbox"]'));
}
